 const Close = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960" 
            fill={color}
        >
            <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
        </svg>
    )
}

export default Close; 